import * as React from 'react';
import { createContext, useContext } from 'react';

// BlockLayout theme context type
export interface BlockLayoutTheme {
  themeName: string;
  isInverted: boolean;
}

// Theme mapping to detect inverted/dark themes
const INVERTED_THEMES = ['blue-bg-invert-fg', 'dark-blue-bg-invert-fg', 'black-bg'];

// Create the context
const BlockLayoutThemeContext = createContext<BlockLayoutTheme | null>(null);

// Custom hook to use BlockLayout theme
export const useBlockLayoutTheme = () => {
  const context = useContext(BlockLayoutThemeContext);

  // Return default values if outside BlockLayout context
  if (!context) {
    return {
      themeName: 'white-bg',
      isInverted: false,
    };
  }

  return context;
};

// Provider component
export const BlockLayoutThemeProvider = ({ themeName, children }: { themeName: string; children: React.ReactNode }) => {
  const contextValue: BlockLayoutTheme = {
    themeName,
    isInverted: INVERTED_THEMES.includes(themeName),
  };

  return <BlockLayoutThemeContext.Provider value={contextValue}>{children}</BlockLayoutThemeContext.Provider>;
};

/**
 * Check if the theme is inverted
 * @param themeName - The name of the theme to check
 * @returns True if the theme is inverted, false otherwise
 */
export const isInvertedTheme = (themeName: string) => INVERTED_THEMES.includes(themeName);
